export default __webpack_public_path__ + "static/lens-piece-1-a1c46c280c4e165190aa06cc04fb29d0.jpg";